import React from 'react';
import { motion } from 'framer-motion';
import { Section, SectionTitle } from '@/components/shared/Section';
import { fadeUp, stagger } from '@/lib/motion';
import { PAIN_POINTS, BENEFICIOS } from '@/data/venddi';

export function VenddiProblem() {
  return (
    <Section>
      <SectionTitle
        badge="EL PROBLEMA"
        title="Tu caja tradicional está frenando tu negocio"
        subtitle="Colas largas, cajeros cansados, errores de tipeo, baja de stock sin aviso, y ventas perdidas por fricción."
        center
      />
      <div className="grid sm:grid-cols-3 gap-4 max-w-5xl mx-auto mt-8">
        {PAIN_POINTS.map((p, i) => (
          <div key={i} className="p-6 rounded-2xl bg-red-50 border border-red-100">
            <p.icon className="w-8 h-8 text-red-500 mb-3" strokeWidth={1.8} />
            <h3 className="text-base font-bold text-[#0A2540] mb-1" style={{ fontFamily: 'Syne,sans-serif' }}>{p.title}</h3>
            <p className="text-sm text-slate-600">{p.desc}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

export function VenddiBenefits() {
  return (
    <Section alt>
      <SectionTitle
        badge="POR QUÉ VENDDI"
        title="Lo que cambia cuando tu kiosco tiene Venddi"
        subtitle="No es un POS más. Es un software pensado 100% para autoservicio, con IA supervisando en tiempo real."
        center
      />
      <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={{ once: true }} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
        {BENEFICIOS.map((b, i) => (
          <motion.div key={i} variants={fadeUp} className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#0EA5E9]/10 flex items-center justify-center shrink-0">
                <b.icon className="w-6 h-6 text-[#0EA5E9]" strokeWidth={1.8} />
              </div>
              <div className="flex-1 min-w-0">
                <div
                  className="text-4xl sm:text-5xl font-black text-[#0A2540] leading-none tracking-tight"
                  style={{ fontFamily: 'Syne,sans-serif', fontVariantNumeric: 'tabular-nums' }}
                >
                  {b.metric}
                </div>
                <div className="text-[11px] font-bold text-[#38BDF8] uppercase tracking-[0.12em] mt-2 mb-2">{b.label}</div>
                <p className="text-sm text-slate-600 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </Section>
  );
}
